import { useState } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import * as React from 'react';
import { Column } from '../../../components/Table/DashboardTable';
import styles from './styles.module.scss';
import { Row } from './index';

export function CollapsibleRowDocument(props: {
  row: Row;
  columns: Column[];
  listOfAllCandidateDocuments?: {
    columns: Column[];
    rows: Row[];
  };
}) {
  const {
    row,
    columns,
    listOfAllCandidateDocuments = { rows: [], columns: [] },
  } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow
        sx={{
          '& > *': { borderBottom: 'unset' },
          '&:last-child td, &:last-child th': { border: 0 },
        }}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
            sx={{ minWidth: '20px !important' }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {row.cells.map((cell: any, index: number) => (
          <TableCell
            align={index === columns.length - 1 ? 'right' : 'left'}
            key={cell.key}
            component={cell.component}
            scope={cell.scope}
          >
            {cell.isBold ? <b>{cell.data}</b> : cell.data}
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 0 }}>
              <Table
                size="small"
                aria-label="purchases"
                className={styles.subTable}
              >
                <TableBody>
                  {listOfAllCandidateDocuments.rows
                    .filter((r: Row) => r.key === row.key)
                    .map((document: any) => (
                      <TableRow key={document.id}>
                        <TableCell
                          sx={{
                            background: '#f7f5f5',
                            width: '7%',
                          }}
                        >
                          <div></div>
                        </TableCell>
                        {document.cells.map((cell: any, index: number) => (
                          <TableCell
                            align={
                              index === columns.length - 1 ? 'right' : 'left'
                            }
                            key={cell.key}
                            component={cell.component}
                            scope={cell.scope}
                            sx={{
                              background: '#f7f5f5',
                              width: cell.width || undefined,
                            }}
                          >
                            {cell.isBold ? <b>{cell.data}</b> : cell.data}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
